import { RootState } from 'src/store/store'
import LoginTemplate from 'src/components/atomic/template/Account/Login'
import useLoginEventBus from 'src/hooks/useEventBus/useLoginEventBus'
import {
  setEmail,
  setSNSType,
  setStatus,
  SNSLoginType,
} from 'src/store/Reducer/page/loginPageSlice'
import jwt_decode from 'jwt-decode'
import { useAppDispatch } from 'src/hooks/redux/useAppDispatch'
import { useAppSelector } from 'src/hooks/redux/useAppSelector'
import { Cmdtypes } from 'src/constants/cmdtypes'
import { useEffect } from 'react'
import { commonUtils } from 'src/utils/common.utils'
import SessionStorageUtils from 'src/utils/SessionStorage.utils'
import {
  ResetErrText,
  setLoadingStatus,
  setRecaptchaRefresh,
} from 'src/store/Reducer/common/commonSlice'

import { RequestDataBody } from 'src/types/websocket'
import { SocketManager, SocketSender } from 'src/api/socket'

type credentialResponseType = {
  clientId: string
  client_id: string
  credential: string
  select_by: string
}

export type FacebookUserResponseType = {
  email: string
  id: string
}

type loginData = {
  email: string
  loginType: number
}
export type LoginProps = {
  SignInBtnHandler: () => void
  GoogleLoginSuccessHandler: (credentialResponse: credentialResponseType) => void
  FaceBookLoginSuccessHandler: (userResponse: FacebookUserResponseType) => void
  SocialLoginSuccessHandler: (loginData: loginData) => void
}

const LoginPage = () => {
  const { Timezone } = commonUtils
  const dispatch = useAppDispatch()
  const { SNSType, pinValue, VerifyPin, Email } = useAppSelector(
    (state: RootState) => state.LoginPage,
  )
  const { RecaptchaRefresh } = useAppSelector((state: RootState) => state.common)
  const { deleteStorageData, getStorageData } = SessionStorageUtils()

  const SocialLoginSuccessHandler = (loginData: loginData) => {
    const isMemberReqData = {
      Email: loginData.email,
      SNSType: loginData.loginType,
    }
    const initializeSocket = async () => dispatch(SocketManager())

    initializeSocket().then(() => {
      dispatch(SocketSender<RequestDataBody.isMember>(Cmdtypes.MEMBER_CHECK, isMemberReqData))
    })

    deleteStorageData('token')
    dispatch(setEmail(loginData.email))
    dispatch(setSNSType(loginData.loginType))
    dispatch(setRecaptchaRefresh(!RecaptchaRefresh))
  }

  const GoogleLoginSuccessHandler = (credentialResponse: credentialResponseType) => {
    dispatch(ResetErrText())

    if (credentialResponse?.credential) {
      const decodeData: { email: string } = jwt_decode(credentialResponse.credential)

      const loginData = {
        email: decodeData.email,
        loginType: SNSLoginType.GOOGLE,
      }

      SocialLoginSuccessHandler(loginData)
    }
  }

  const FaceBookLoginSuccessHandler = (userData: FacebookUserResponseType) => {
    dispatch(ResetErrText())

    if (userData) {
      const loginData = {
        email: userData.email ?? '',
        loginType: SNSLoginType.FACEBOOK,
      }

      SocialLoginSuccessHandler(loginData)
    }
  }

  const SignInBtnHandler = () => {
    const LoginReqData = {
      SNSType: SNSType,
      Email: Email,
      VerifyPin: VerifyPin,
      Token: getStorageData('token'),
      TimeZone: Timezone,
    }
    if (pinValue?.length === 6) {
      dispatch(setLoadingStatus(true))
      dispatch(SocketSender(Cmdtypes.LOGIN, LoginReqData))
    }
  }

  useLoginEventBus()

  useEffect(() => {
    return () => {
      dispatch(setStatus('default'))
    }
  }, [dispatch])

  const data: LoginProps = {
    SignInBtnHandler,
    SocialLoginSuccessHandler,
    GoogleLoginSuccessHandler,
    FaceBookLoginSuccessHandler,
  }

  return <LoginTemplate data={data} />
}
export default LoginPage
